import { Form, Modal } from 'reactstrap';
import { CANCEL, EMAILS_SCHEDULED_SUCCESSFULLY, ERROR_SCHEDULING_EMAILS, MESSAGE_TEXT, SEND, STEP_2_SEND_EMAILS, SUBJECT_TEXT } from '../../constants';
import CustomButton from '../../components/layout/CustomButton';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { SEND_EMAIL_TO_CONTACTS } from './gql';

const EmailModal = ({ isOpen, toggle, fileId }) => {
  const { handleSubmit, register, formState: { errors } } = useForm();

  const [emailMutation, { loading: emailSending }] = useMutation(SEND_EMAIL_TO_CONTACTS, {
    onCompleted: () => {
      toast.success(EMAILS_SCHEDULED_SUCCESSFULLY)
    },
    onError: (error) => {
      const errorMessage = error.graphQLErrors?.[0]?.message || ERROR_SCHEDULING_EMAILS;
      toast.error(errorMessage);
    },
  })

  const sendEmail = async (values) => {
    await emailMutation({
      variables: {
        input: {
          subject: values.subject,
          bodyContent: values.message,
          fileId: fileId
        },
      },
    });
    toggle();
  };


  return (
    <Modal isOpen={isOpen} toggle={toggle} className="revampDialog revampDialogWidth">
      <Form>
        <div className="p-4">
          <p className="mb-4" style={{ fontWeight: 700 }}>{STEP_2_SEND_EMAILS}</p>

          <div className="mb-3">
            <label style={{ fontWeight: 700 }}>{SUBJECT_TEXT}</label>
            <input
              {...register("subject", {
                required: {
                  value: true,
                  message: 'Enter Subject',
                },
              })}
              className="form-control"
              placeholder="User Invite"
            />
            <small className="text-danger pt-2">
              {errors?.subject?.message as any}
            </small>
          </div>

          <div className="mb-3">
            <label style={{ fontWeight: 700 }}>{MESSAGE_TEXT}</label>
            <textarea
              {...register("message", {
                required: {
                  value: true,
                  message: 'Enter Message',
                },
              })}
              className="form-control chat-textarea"
              style={{ minHeight: '200px', maxHeight: '400px' }}
              placeholder="Write your message here..."
            />
            <small className="text-danger pt-2">
              {errors?.message?.message as any}
            </small>
          </div>

          <div className="d-flex align-items-center justify-content-end mt-4">
            <button
              type="button"
              className="buttonGenericStyle buttonPrimary"
              onClick={toggle}
            >
              {CANCEL}
            </button>
            <div className="px-2" />
            <CustomButton
              buttonText={SEND}
              buttonColor="primary"
              buttonType="submit"
              buttonClick={handleSubmit(sendEmail)}
              loading={emailSending}
            />
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default EmailModal;